// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-vital-chart[data-v-0198f3a4]{width:100%}.aroma-vital-chart__grid[data-v-0198f3a4]{display:grid;gap:2.66667vw}.aroma-vital-chart__panel[data-v-0198f3a4]{overflow:hidden;border:1px solid #dce8f2;border-radius:2.13333vw;background:#f8fcff}.aroma-vital-chart h3[data-v-0198f3a4]{margin:0;padding:2.4vw 3.2vw 0;color:#1a3f6a;font-size:3.46667vw;font-weight:600;line-height:5.33333vw}.aroma-vital-chart__canvas[data-v-0198f3a4]{width:100%;height:58.66667vw}", ""]);
// Exports
module.exports = exports;
